// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__17okT","header":"ReportDetails_header__1pk14","title":"ReportDetails_title__h3RtI","left":"ReportDetails_left__2589a"};